import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import OperatorMetricsPage from "./index"


export const VtOperatorMetricsRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.OPERATOR_METRICS_PATH,
	title: VISIBILITY_TRACKER_ROUTES.OPERATOR_METRICS_TITLE,
	icon: 'stopwatch',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Per-operator tagging time — average per section, totals, and drill-down',
	access: USER_ROLE.ADMIN,
	children: [{
		element: <OperatorMetricsPage />,
		index: true
	}]
}
